var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCustomerSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "800px",
    height: "800px",
    viewBox: "0 0 800 800",
    style: {
      enableBackground: "new 0 0 800 800"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M261,281.2L261,281.2c13.5,69,74,119.5,144.5,119.5s130.9-50.5,144.5-119.5l17.8-90.4c5.7-44.1-7.1-88.2-36.3-121.7 s-71.2-52.7-115.3-52.7h-20.6c-44.1,0-86.1,19.2-115.3,52.7s-42.7,77.6-36.3,123.8L261,281.2z M333.6,116.1 c15.7-17.8,38.4-28.5,62.6-28.5h20.6c24.2,0,46.3,10,62.6,28.5c15.7,17.8,22.8,42,19.9,63.3l-17.1,88.2 c-7.1,36.3-38.4,61.9-75.4,61.9s-68.3-26.3-75.4-61.9l-17.1-86.1C310.1,158.1,317.9,133.9,333.6,116.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M530,539.5l96.8,33.4l40.6,192.1c3.6,16.4,18.5,27.8,34.9,27.8c2.1,0,5,0,7.1-0.7c19.2-4.3,31.3-22.8,27-42L695.8,558 c-5-23.5-22.1-42.7-44.1-50.5l-140.2-49.8l-106,106l-105.3-106L160,507.5c-22.1,7.8-39.1,27-44.1,50.5L75.3,750.2 c-4.3,19.2,7.8,37.7,27,42s37.7-7.8,42-27l39.1-190.7l98.2-34.9l123.8,123.8L530,539.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerSuccess);
export default __webpack_public_path__ + "static/media/customerSuccess.03aa4765cd7162436aff19b425c7345d.svg";
export { ForwardRef as ReactComponent };